<template>
  <div>
    <OneCompetence
      :showCompentence="showCompentence"
      @close="showCompentence = false"
    ></OneCompetence>
    <div class="p-2">
      <ve-table :columns="columns" :table-data="tableData" />
    </div>
  </div>
</template>

<script>
import OneCompetence from "./oneCompetence.vue";
export default {
  name: "MyReviewsCompetence",
  components: { OneCompetence },
  data() {
    return {
      showCompentence: false,
      columns: [
        {
          field: "Competency",
          key: "a",
          title: "Competency",
          renderBodyCell: ({ row }) => {
            return (
              <p
                on-click={() => (this.showCompentence = true)}
                class="text-blue-500 cursor-pointer"
              >
                {row.Competency}
              </p>
            );
          },
        },
        { field: "DueDate", key: "b", title: "Due Date" },
        {
          field: "Attachment",
          key: "c",
          title: "Attachment",
          renderBodyCell: () => {
            return <p class="cursor-pointer font-bold">&#128206;</p>;
          },
        },
        { field: "MyReview", key: "d", title: "MyReview" },
        { field: "Feedback", key: "e", title: "Feedback" },
      ],
      tableData: [
        {
          Competency: "Agility",
          DueDate: "15 Dec 2022",
          Attachment: "",
          MyReview: "98%",
          Feedback: "",
        },
      ],
    };
  },
};
</script>
